const parametersMenu = {
  account: 'Account',
  seo: 'SEO',
  language: 'Language',
}

export default parametersMenu
